// toString(36) drops trailing zeros, so the raw slice is shorter than ten
// characters about 0.7% of the time. Padded so the length is what callers
// (and the test) assume.
export const randomId = () =>
	Math.random().toString(36).substring(2, 12).padEnd(10, "0");
